

export const fishSpecies = [

    {
        label: {
            fi: "Ankerias",
            sv: "Ål",
            en: "Eel",
            latin: "Anguilla anguilla"
        },
        value: "ELE"
    },
    {
        label: {
            fi: "Nahkiainen",
            sv: "Nejonöga",
            en: "Lampern",
            latin: "Anguilla anguilla"
        },
        value: "LAR"
    },
    {
        label: {
            fi: "Toutain",
            sv: "Asp",
            en: "Asp",
            latin: "Aspius aspius"
        },
        value: "ASU"
    },
    {
        label: {
            fi: "Suutari",
            sv: "Sutare",
            en: "Tench",
            latin: "Tinca tinca"
        },
        value: "FTE"
    },
    {
        label: {
            fi: "Turska",
            sv: "Torsk",
            en: "Cod",
            latin: "Gadus morhua"
        },

        value: "COD"
    },
    {
        label: {
            fi: "Lahna",
            sv: "Brax",
            en: "Freshwater bream",
            latin: "Abramis brama"
        },
        value: "FBM"
    },
    {
        label: {
            fi: "Made",
            sv: "Lake",
            en: "Burbot",
            latin: "Lota lota"
        },
        value: "FBU"
    },
    {
        label: {
            fi: "Säyne",
            sv: "Id",
            en: "Ide",
            latin: "Leuciscus idus"
        },
        value: "FID"
    },
    {
        label: {
            fi: "Kampela",
            sv: "Flundra",
            en: "Flounder",
            latin: "Platichtys flesus"
        },
        value: "FLE"
    },
    {
        label: {
            fi: "Hauki",
            sv: "Gädda",
            en: "Pike",
            latin: "Esox lucius"
        },
        value: "FPI"
    },
    {
        label: {
            fi: "Kuha",
            sv: "Gös",
            en: "Pikeperch, zander",
            latin: "Stizostedion lucioperca"
        },
        value: "FPP"
    },
    {
        label: {
            fi: "Ahven",
            sv: "Abborre",
            en: "European perch",
            latin: "Perca fluviatilis"
        },
        value: "FPE"
    },
    {
        label: {
            fi: "Kiiski",
            sv: "Gärs",
            en: "Ruff",
            latin: "Acerina cernua"
        },
        value: "FRF"
    },
    {
        label: {
            fi: "Särki",
            sv: "Mört",
            en: "Roach",
            latin: "Leuciscus rutilus"
        },
        value: "FRO"
    },
    {
        label: {
            fi: "Muikku",
            sv: "Siklöja",
            en: "Vendace",
            latin: "Coregonus albula"
        },
        value: "FVE"
    },
    {
        label: {
            fi: "Silakka",
            sv: "Strömming",
            en: "Baltic herring",
            latin: "Clupea harengus"
        },
        value: "HER"
    },
    {
        label: {
            fi: "Lohi, merilohi",
            sv: "Lax",
            en: "Atlantic salmon",
            latin: "Salmo salar"
        },
        value: "SAL"
    },
    {
        label: {
            fi: "Kuore",
            sv: "Nors",
            en: "Smelt Osmerus",
            latin: "eperlanus"
        },
        value: "SME"
    },
    {
        label: {
            fi: "Kilohaili",
            sv: "Vassbuk",
            en: "Sprat",
            latin: "Sprattus sprattus"
        },
        value: "SPR"
    },
    {
        label: {
            fi: "Kirjolohi",
            sv: "Regnbågsforell",
            en: "Rainbow trout",
            latin: "Oncorhynchus mykiss"
        },
        value: "TRR"
    },
    {
        label: {
            fi: "Taimen, meritaimen",
            sv: "Havsöring",
            en: "Sea trout",
            latin: "Salmo trutta"
        },
        value: "TRS"
    },
    {
        label: {
            fi: "Piikkikampela",
            sv: "Piggvar",
            en: "Turbot",
            latin: "Psetta maxima"
        },
        value: "TUR"
    },
    {
        label: {
            fi: "Siika",
            sv: "Sik",
            en: "European whitefish, powan",
            latin: "Coreconus lavaretus"
        },
        value: "WHF"
    },
    {
        label: {
            fi: "Punakampela",
            sv: "Rödspätta",
            en: "Plaice",
            latin: "Pleuronoectes platessa"
        },
        value: "PLE"
    },
    {
        label: {
            fi: "Simppu",
            sv: "Simpa",
            en: "Sculpin",
            latin: "Taurulus bubalis"
        },
        value: "SCU"
    },
    {
        label: {
            fi: "Valkoturska",
            sv: "Vitling",
            en: "Whiting",
            latin: "Merlangius merlangus"
        },
        value: "WHG"
    },
    {
        label: {
            fi: "Makrilli",
            sv: "Makrill",
            en: "Atlantic mackerel",
            latin: "Scomber scombrus"
        },
        value: "MAC"
    },
]